module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"#ffaa00","showSpinner":false},
    },{
      plugin: require('../node_modules/@carrotsearch/gatsby-transformer-html/gatsby-browser.js'),
      options: {"plugins":[],"variables":{"VERSION":"2.0.1"},"transformers":[null,null,null,null,null,null,null],"finalizers":[null]},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/@carrotsearch/gatsby-theme-apidocs/gatsby-browser.js'),
      options: {"plugins":[],"navigation":"/home/runner/work/lingo4g/lingo4g/doc/src/navigation.json","logo":"/home/runner/work/lingo4g/lingo4g/doc/src/logo.html","footer":"/home/runner/work/lingo4g/lingo4g/doc/src/footer.html","basePath":"src/content","variables":{"VERSION":"2.0.1"},"transformers":[null,null,null,null,null,null,null],"finalizers":[null]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
